import type CustomAction from "@/createProposal/action/CustomAction"
import type ManageOrcaPodAction from "@/createProposal/action/ManageOrcaPodAction"
import type TallyAction from "@/createProposal/action/TallyAction"
import type TransferErc20Action from "@/createProposal/action/TransferErc20Action"
import type TransferNativeAssetAction from "@/createProposal/action/TransferNativeAssetAction"
import type { ExecutableCall } from "@/query/graphql"
import { ExecutableCallType } from "@/query/graphql"

export type TallyActionArgs = {
  targetAddress?: string
  value?: string
}

export type ExecutableCallForBlockchain = Omit<
  ExecutableCall,
  "offchaindata" | "type" | "index" | "chainId"
>

export type Action =
  | TallyAction
  | CustomAction
  | TransferErc20Action
  | TransferNativeAssetAction
  | ManageOrcaPodAction

export const recipeReadableMap: { [key in ExecutableCallType]: string } = {
  [ExecutableCallType.Custom]: "Custom",
  [ExecutableCallType.Empty]: "Empty",
  [ExecutableCallType.Erc20transfer]: "Transfer",
  [ExecutableCallType.Erc20transferarbitrum]: "Transfer",
  [ExecutableCallType.Nativetransfer]: "Transfer",
  [ExecutableCallType.Other]: "Other",
  [ExecutableCallType.Orcamanagepod]: "Orca Pod",
  [ExecutableCallType.Reward]: "Reward",
  [ExecutableCallType.Swap]: "Swap",
}
